module.exports = __webpack_public_path__ + "static/img/torso13.97af7692.jpg";